import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(frontend)/[locale]/news/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Antonie/Components/animated-text.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsCard"] */ "/app/src/components/NewsCard/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Pagination"] */ "/app/src/components/Pagination/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderClient"] */ "/app/src/Header/Component.client.tsx");
